/**
 * A readable title from an uploaded track file's name.
 *
 * FIT files carry no activity title. The format has a `name`, but it is the
 * sport profile — "Run", "Walk" — so using it would title every import the
 * same; `sample.fit` has none at all. The filename is the only real source,
 * and the exporters that produce it substitute underscores for spaces:
 * Garmin Connect writes `Afternoon_Hike.fit`, Strava `Morning_Ride.fit`.
 * Those underscores were reaching the recordings list verbatim.
 *
 * Underscores only. Hyphens are left alone deliberately — device exporters
 * date-stamp their filenames (`2026-08-07-171500-ELEMNT.fit`), and turning
 * those separators into spaces would mangle the date rather than reveal words.
 */
export function titleFromFileName(fileName: string | null | undefined): string {
  // Same extension strip the call sites already used, so that part is unchanged.
  const base = String(fileName ?? '').replace(/\.[^/.]+$/, '');
  const cleaned = base.replace(/_+/g, ' ').replace(/\s+/g, ' ').trim();

  // A name that is nothing but separators keeps what it had rather than
  // becoming empty — no worse than before, and there is nothing better to show.
  return cleaned || base;
}
